module.exports = __webpack_public_path__ + "static/media/laughingPeople.f2acf769.png";